import styled from '@emotion/styled';
import { H3 } from 'ds/components/typography';
import { typographyFontSizeCfg } from 'ds/components/typography/types';
import { BADGE_SIZE } from 'screens/AgentOfficePages/common/components/Badge/styled';


export const AwardsWrapper = styled.div`
`;

export const MobileTitle = styled(H3.withComponent('div'))`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const Page = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    gap: ${theme.spacing(2)};
  `}
`;

export const ShowMoreWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(1)};
  margin-bottom: -${({ theme }) => theme.spacing(1)};
  && > * {
    font-size: ${typographyFontSizeCfg.text}px;
  }
`;

export const ScrollBoxWrapper = styled.div`
  .scrollBox {
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;

export const BadgeSizeSpace = styled.div`
  position: relative;
  height: ${BADGE_SIZE.height}px;
`;

export const InfiniteAnimationScrollSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  overflow: hidden;
  :hover > * {
    animation-play-state: paused;
  }
`;

export const ScrollSectionFirst = styled.div<{  animationTime: number }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  animation: marquee ${({ animationTime }) => animationTime}s linear infinite;
  @keyframes marquee {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }
`;

export const ScrollSectionLast = styled(ScrollSectionFirst)`
  animation: marquee2 ${({ animationTime }) => animationTime}s linear infinite;
  @keyframes marquee2 {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }
`;

export const CarouselWrapper = styled.div`
  ${({ theme }) => `
    margin-top: -${theme.spacing(3)};
    width: 100%;
    > div > div {
      height: 96px;
      &:after, &:before {
        display: none;
      }
    }
}
  `}
  [dir="prev"] {
    right: 0;
  }
  [dir="next"] {
    left: 0;
  }
`;
